import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export class ObservableManager {
  /**
   * A subject to release observables
   */
  private stopSubject: Subject<boolean> = new Subject();

  constructor() {
    /** */
  }

  /**
   * Add release watch to the observable and return a new observable
   *
   * @param observable
   */
  watch<T>(observable: Observable<T>): Observable<T> {
    return observable.pipe(takeUntil(this.stopSubject));
  }

  /**
   * release the subscriptions
   */
  release() {
    this.stopSubject.next(true);
    this.stopSubject.complete();
  }
}
